import { useState } from "react";
import "./TopNav.css";

export type PublicPage = "home" | "story" | "info";

type TopNavProps = {
  activePage: PublicPage;
};

const links: Array<{ href: string; label: string }> = [
  { href: "/#schedule", label: "Program" },
  { href: "/#ceremony-master", label: "Ceremóniamester" },
  { href: "/#travel", label: "Helyszínek" },
  { href: "/#lodging", label: "Szállás" },
  { href: "/rsvp/", label: "Visszajelzés" }
];

export default function TopNav(_props: TopNavProps): JSX.Element {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((open) => !open);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="topNav" aria-label="Fő navigáció">
      <div className="container topNav__inner">
        <a className="topNav__brand" href="/" onClick={closeMenu}>
          <span>Fanni</span>
          <em>&amp;</em>
          <span>Marci</span>
        </a>
        <button
          className={["topNav__mobileToggle", menuOpen ? "is-open" : ""]
            .join(" ")
            .trim()}
          aria-label={menuOpen ? "Navigáció bezárása" : "Navigáció megnyitása"}
          aria-expanded={menuOpen}
          aria-controls="main-navigation"
          type="button"
          onClick={toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
        <ul
          id="main-navigation"
          className={["topNav__links", menuOpen ? "is-open" : ""]
            .join(" ")
            .trim()}
        >
          {links.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={closeMenu}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
